// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","lightBackground":"#f3f7f8","text":"#3c3c3f","primary":"#618c03","primaryLight":"#a5bf6b","primaryNeon":"#97bf04","primaryDark":"#365902"};